import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
} from "reactstrap";
import { withNamespaces } from "react-i18next";
const ConfirmUserStatusModal = ({ 
    t,
    isOpen, 
    toggle, 
    onConfirm, 
    user,
    isLoading
}) => {
    const isActivating = user?.status === 'INACTIVE' ? true : false;
    const userName = user ? `${user.first_name} ${user.last_name}` : '';

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t(isActivating ? 'Activate User' : 'Deactivate User')}
            </ModalHeader>
            <ModalBody>
                <p className="mb-2">
                    {isActivating ? t('Do you want to activate this user?') : t('Are you sure you want to deactivate this user? This user will no longer have access to the platform.')}
                </p>
                <strong>{userName}</strong>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
                <Button 
                    disabled={isLoading}
                    color={isActivating ? 'success' : 'danger'} 
                    onClick={() => {
                        const nextStatus = user?.status === 'INACTIVE' ? 'ACTIVE' : 'INACTIVE';

                        onConfirm({
                            userId: user?.id,
                            nextStatus
                        })
                    }}>
                    {isLoading && (
                        <Spinner 
                            color="white"
                            size="sm"
                            className="me-1"
                        />
                    )}
                    {t('Yes')}, {t(isActivating ? 'Activate' : 'Deactivate')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    ConfirmUserStatusModal
)